export default "__VITE_ASSET__fd97bdd3__"